/**
 * LoanCharts — extracted from LoansPage during Iter28 refactor.
 *
 * Renders the two analytics charts (status pie + monthly trends bar) side by
 * side. Pure presentational — receives the loan summary payload.
 */
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '../ui/card';
import {
  PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Legend,
} from 'recharts';
import { formatCurrency } from '../../lib/utils';

const COLORS = ['#1E88E5', '#2E7D32', '#E53935'];

const LoanCharts = ({ summary }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <Card className="card-hover" data-testid="loan-status-chart">
      <CardHeader>
        <CardTitle className="font-heading">Loan Portfolio Status</CardTitle>
        <CardDescription>Distribution of loan statuses</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-64">
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={summary?.status_distribution || []}
                cx="50%" cy="50%"
                innerRadius={60} outerRadius={90}
                paddingAngle={2} dataKey="value"
                label={({ name, value }) => `${name}: ${value}`}
              >
                {(summary?.status_distribution || []).map((entry, idx) => (
                  <Cell key={entry.name || `cell-${idx}`} fill={COLORS[idx % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>

    <Card className="card-hover" data-testid="loan-trends-chart">
      <CardHeader>
        <CardTitle className="font-heading">Monthly Loan Activity</CardTitle>
        <CardDescription>Disbursements vs Repayments</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-64">
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={summary?.monthly_trends || []}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
              <XAxis dataKey="month" />
              <YAxis tickFormatter={(v) => `${(v / 1000000).toFixed(1)}M`} />
              <Tooltip
                formatter={(value) => formatCurrency(value)}
                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
              />
              <Legend />
              <Bar dataKey="disbursed" name="Disbursed" fill="#1E88E5" radius={[4, 4, 0, 0]} />
              <Bar dataKey="repaid" name="Repaid" fill="#2E7D32" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  </div>
);

export default LoanCharts;
